<style>
    @media screen and (max-width: 1400px) {
        .upload-req-steps-container>.steps>li {
            font-size: 14px !important;
            padding: 0 10px 0 20px;
        }

        .upload-req-steps-container>.steps>li>span {
            display: none;
        }
    }

    .license-pref-label {
        font-size: 1em;
    }

    .license-pref-label-disabled {
        opacity: 0.4;
    }

    .license-pref-label-disabled span {
        font-weight: 250;
    }

    .multi-select-error button {
        border-color: red;
    }

    .mr-1 {
        margin-right: 7px;
    }

    .job-boards-pull-limit-warning-container {
        padding-left: 45px;
        margin-top: 10px
    }

    .job-boards-pull-limit-warning {
        padding: 5px;
        border: 1px solid lightgrey;
    }

    .upload-req-cancel-button-container {
        display: flex;
        justify-content: flex-end
    }

    .threshold-score-label {
        padding-left: 54px;
        margin-top: 33px;
        display: inline-block;
    }

    .candidate-job-match-card-not-available-icon {
        font-size: 10px;
        position: absolute;
        top: 1px;
    }

    .step-pane {
        display: none;
    }

    .step-pane.active {
        display: block;
    }
</style>
<div class="approw">
    <div class="row">
        <div class="col-lg-12">
            <div id="content-header" class="clearfix">
                <div class="pull-left">
                    <ol class="breadcrumb">
                        <li><a ui-sref-opts="{reload: true}" ui-sref="missioncontrol.dashboard">{{ MESSAGECONSTANTS.BREADCRUMBS.HOME }}</a></li>
                        <li class="active" [hidden]="!(showWizardSteps && !isLoading && isJobFetched)">
                            <span *ngIf="!editModeFlag">Add New Requisition</span>
                            <span *ngIf="editModeFlag">Edit Requisition</span>
                        </li>
                    </ol>
                    <h1 class="heading-css" [hidden]="!(showWizardSteps && !isLoading && isJobFetched)">
                        <span *ngIf="!editModeFlag">Upload Requisition</span>
                        <span *ngIf="editModeFlag">
                            Edit <i>'<span>{{ job?.title }}</span>'</i>
                        </span>
                    </h1>
                    <div [hidden]="showWizardSteps && !isLoading && isJobFetched" class="skeleton-container pl-4">
                        <div class="skeleton-heading width-50 skeleton-loading my-0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row fuelux" [hidden]="!(showWizardSteps && !isLoading && isJobFetched)">
        <div class="col-lg-12">
            <div class="main-box clearfix">
                <div class="main-box-body clearfix wizardmainbox">
                    <div class="row d-flex align-items-center">
                        <div class="col-xs-10" *ngIf="currentJobStatus !== 'DRAFT'">
                            <div *ngIf="!isJobFetched" class="skeleton-container pl-4">
                                <div class="skeleton-heading width-75 skeleton-loading my-0"></div>
                            </div>
                            <div *ngIf="isJobFetched" class="workflow-header">
                                <h1 id="candidateWorkflowTitle" class="heading-css cursor-default" style="margin-bottom: 0px; font-size:18px;">
                                    <span class="badge badge-primary text-overflow-ellipsis mr-2" style="font-size: 0.8em;">
                                        <span *ngIf="job?.requisitionNumber" tooltip="Requisition Number" container="body" placement="top" [adaptivePosition]="false">{{ job.requisitionNumber }}</span>
                                        <span *ngIf="job?.locationLabel" tooltip="Location" container="body" placement="top" [adaptivePosition]="false"> - {{ job.locationLabel }}</span>
                                    </span>
                                    <span *ngIf="job?.clientorbu?.name" class="badge badge-primary mr-2" [tooltip]="job.clientorbu.name" container="body" placement="top" [adaptivePosition]="false" style="font-size: 0.8em;">{{ job.clientorbu.name }}</span>
                                    <span *ngIf="job?.jobTypeLabel" tooltip="Job Type" container="body" placement="top" [adaptivePosition]="false" class="badge badge-primary cursor-default mr-2" style="font-size: 0.8em;">
                                        {{ job.jobTypeLabel }} <span *ngIf="job.contractDuration">({{ job.contractDuration }} months)</span>
                                    </span>
                                    <span class="badge badge-primary cursor-pointer position-relative mr-2" style="line-height:inherit; font-size:0.80em">
                                        <i *ngIf="job?.requisitionSalaryDisplayMessage !== 'Not Available'" class="fas fa-dollar-sign"
                                            [popover]="jobMatchSalaryPopover" [popoverTitle]="job?.salaryLabel"
                                            placement="bottom" containerClass="additional-details-pop-over candidate-job-match-card-popover" triggers="mouseenter:mouseleave">
                                        </i>
                                        <i *ngIf="job?.requisitionSalaryDisplayMessage === 'Not Available'" class="fas fa-dollar-sign"
                                            tooltip="Job Salary not available" container="body"></i>
                                        <span *ngIf="job?.requisitionSalaryDisplayMessage === 'Not Available'"
                                            class="fa fa-times red candidate-job-match-card-not-available-icon" style="left:11px;"></span>
                                    </span>
                                    <span class="badge badge-primary cursor-pointer position-relative mr-2" style="line-height:inherit; font-size:0.80em">
                                        <i *ngIf="job?.sponsorships && job.sponsorships.length > 0" class="fas fa-award"
                                            [popover]="jobMatchSponsorshipsPopover" popoverTitle="Sponsorships"
                                            placement="bottom" containerClass="additional-details-pop-over candidate-job-match-card-popover" triggers="mouseenter:mouseleave">
                                        </i>
                                        <i *ngIf="!job?.sponsorships || job.sponsorships.length === 0" class="fas fa-award"
                                            tooltip="Job Sponsorships not available" container="body"></i>
                                        <span *ngIf="!job?.sponsorships || job.sponsorships.length === 0"
                                            class="fa fa-times red candidate-job-match-card-not-available-icon" style="left: 13.5px"></span>
                                    </span>
                                    <span class="badge badge-primary cursor-pointer position-relative mr-2" style="line-height:inherit; font-size:0.80em">
                                        <i *ngIf="job?.workLocations && job.workLocations.length > 0" class="far fa-building"
                                            [popover]="jobWorkLocationsPopover" popoverTitle="Work Locations"
                                            placement="bottom" containerClass="additional-details-pop-over candidate-job-match-card-popover" triggers="mouseenter:mouseleave">
                                        </i>
                                        <i *ngIf="!job?.workLocations || job.workLocations.length === 0" class="far fa-building"
                                            tooltip="Job Work locations not available" container="body"></i>
                                        <span *ngIf="!job?.workLocations || job.workLocations.length === 0"
                                            class="fa fa-times red candidate-job-match-card-not-available-icon" style="left: 14px"></span>
                                    </span>
                                    <span *ngIf="requisitionInfo">
                                        <app-requisition-card-icons [requisitionInfo]="requisitionInfo" [isRowViewActive]="false"
                                            [isAdditionalDetails]="false" [isInternalRequisitionEdit]="true">
                                        </app-requisition-card-icons>
                                    </span>
                                </h1>
                            </div>
                        </div>
                        <div class="upload-req-cancel-button-container main-box-header"
                            [ngClass]="{'col-xs-2': currentJobStatus !== 'DRAFT', 'col-xs-12': currentJobStatus === 'DRAFT'}">
                            <button type="button" class="btn btn-danger btn-cancel" (click)="cancel()" [disabled]="disableCancelButtonFlag || disableAllButtonsFlag">
                                <span class="glyphicon glyphicon-remove mr-2"></span>Cancel
                            </button>
                        </div>
                    </div>
                    <div class="wizard" id="uploadReqWizard">
                        <div class="steps-container" [ngClass]="{'upload-req-steps-container': currentJobStatus === 'DRAFT'}">
                            <ul class="steps">
                                <li data-step="1" data-name="upload" [class.active]="currentStep === 1">
                                    <span class="badge">1</span>
                                    <span *ngIf="currentJobStatus === 'DRAFT'">Create Job Description</span>
                                    <span *ngIf="currentJobStatus !== 'DRAFT'">Edit Job Description</span>
                                    <span class="chevron"></span>
                                </li>
                                <li data-step="2" data-name="recruiters" [class.active]="currentStep === 2">
                                    <span class="badge">2</span>General Information<span class="chevron"></span>
                                </li>
                                <li data-step="3" data-name="workflow" [class.active]="currentStep === 3">
                                    <span class="badge">3</span>Workflow Settings<span class="chevron"></span>
                                </li>
                                <li data-step="4" data-name="jobBoards" [class.active]="currentStep === 4">
                                    <span class="badge">4</span>Job Boards<span class="chevron"></span>
                                </li>
                                <li *ngIf="isInitialStateDraft" data-step="5" data-name="activate" [class.active]="currentStep === 5">
                                    <span class="badge">5</span>Activate<span class="chevron"></span>
                                </li>
                                <li *ngIf="!isInitialStateDraft" data-step="6" data-name="results" [class.active]="currentStep === 5">
                                    <span class="badge">5</span>
                                    View Results<span class="chevron"></span>
                                </li>
                            </ul>
                        </div>
                        <div class="actions">
                            <button type="button" class="btn btn-info btn-prev mr-2" (click)="goToPreviousStep()" [disabled]="currentStep === 1 || disableAllButtonsFlag">
                                <span class="glyphicon glyphicon-arrow-left"></span>Prev
                            </button>
                            <button type="button" class="btn btn-info btn-save mr-2" [disabled]="disableSaveButtonFlag || disableAllButtonsFlag" (click)="saveCurrentStep()">
                                <span class="fa fa-save mr-2"></span>
                                <span *ngIf="!savingFlag">Save</span>
                                <span *ngIf="savingFlag">Saving ...</span>
                            </button>
                            <button type="button" class="btn btn-info btn-next" (click)="goToNextStep()" [disabled]="disableNextButtonFlag || disableAllButtonsFlag">
                                <ng-container *ngIf="currentStep !== 5">Next<span class="glyphicon glyphicon-arrow-right"></span></ng-container>
                                <ng-container *ngIf="currentStep === 5">Complete</ng-container>
                            </button>
                        </div>
                        <div class="step-content" [hidden]="!showWizardSteps">
                            <div class="step-pane sample-pane alert" [class.active]="currentStep === 1" data-step="1">
                                <app-upload-req-step-upload
                                    [currentJobStatus]="currentJobStatus"
                                    [editModeFlag]="editModeFlag"
                                    [userDetails]="userDetails"
                                    [clientOrBuList]="clientorbulist"
                                    [clientOrBuIsRequiredFlag]="clientOrBUIsRequiredFlag"
                                    [req]="req"
                                    [job]="job"
                                    [sharedClientBus]="sharedClientBus"
                                    [sharedClientBuOrCorp]="sharedClientBuOrCorp"
                                    [isLoadingSharedClientBus]="isLoadingSharedClientBus"
                                    [isClientOrBuDisabled]="isClientOrBuDisabled"
                                    [isClientOrBuRequired]="isClientOrBuRequired"
                                    [isUploadRequisition]="isUploadRequisition"
                                    [isUploadAndEditRadioBtn]="isUploadAndEditRadioBtn"
                                    [disableUploadButtonFlag]="disableUploadButtonFlag"
                                    [fileUploadInProgressFlag]="fileUploadInProgressFlag"
                                    [step1Error]="step1Error"
                                    [isJobFetched]="isJobFetched"
                                    [isLoading]="isLoading"
                                    [requisitionSkillsLoading]="requisitionSkillsLoading"
                                    [allExistingSkills]="allExistingSkills"
                                    [allExistingDegrees]="allExistingDegrees"
                                    [allExistingFieldOfStudy]="allExistingFieldOfStudy"
                                    [allExistingRoles]="allExistingRoles"
                                    [allExistingCertificates]="allExistingCertificates"
                                    [allExistingJDActionWords]="allExistingJDActionWords"
                                    [timePeriods]="timePeriods"
                                    [skillsTimePeriods]="skillsTimePeriods"
                                    [dropzoneConfig]="dropzoneConfig"
                                    (clientChangeCallback)="onClientChange()"
                                    (sharedClientBuOrCorpChangeCallback)="sharedClientBuOrCorp = $event; onSharedClientChanged(1)"
                                    (uploadRequisitionTypeChangeCallback)="isUploadRequisition = $event; updateRequisitionDetails()"
                                    (uploadRequisitionCallback)="uploadRequisition()"
                                    (updateLocationCallback)="updateLocation()"
                                    (showJobProfileCallback)="showJobProfile()"
                                    (dropzoneFormReadyCallback)="onUploadDropzoneReady()"
                                    (fileAddedCallback)="onReqUploadFileAdded()"
                                    (fileRemovedCallback)="onReqUploadFileRemoved()"
                                    (fileSendingCallback)="onReqUploadFileSending($event)"
                                    (fileSuccessCallback)="onReqUploadFileSuccess($event)"
                                    (fileErrorCallback)="onReqUploadFileError($event)">
                                </app-upload-req-step-upload>
                            </div>
                            <div class="step-pane sample-pane alert" [class.active]="currentStep === 2" data-step="2">
                                <app-upload-req-step-recruiters
                                    [job]="job"
                                    [currentJobStatus]="currentJobStatus"
                                    [userDetails]="userDetails"
                                    [editTitleFlag]="editTitleFlag"
                                    [editBUFlag]="editBUFlag"
                                    [clientOrBUIsRequiredFlag]="clientOrBUIsRequiredFlag"
                                    [clientOrBuLabel]="clientOrBuLabel"
                                    [clientorbulist]="clientorbulist"
                                    [isLoadingSharedClientBus]="isLoadingSharedClientBus"
                                    [sharedClientBus]="sharedClientBus"
                                    [sharedClientBuOrCorp]="sharedClientBuOrCorp"
                                    [jobTypeList]="jobTypeList"
                                    [selectedJobTypes]="selectedJobTypes"
                                    [contractDurations]="contractDurations"
                                    [workLocationsList]="workLocationsList"
                                    [selectedWorkLocationsList]="selectedWorkLocationsList"
                                    [salaryLabel]="salaryLabel"
                                    [currencyCodes]="currencyCodes"
                                    [salaryDurationOptions]="salaryDurationOptions"
                                    [sponsorshipList]="sponsorshipList"
                                    [recruiterList]="recruiterList"
                                    [selectedRecruiters]="selectedRecruiters"
                                    [isCorporate]="isCorporate"
                                    [hiringManagerList]="hiringManagerList"
                                    [selectedHiringManagers]="selectedHiringManagers"
                                    [primaryHiringManagerList]="primaryHiringManagerList"
                                    [primaryHiringManagerId]="primaryHiringManagerId"
                                    [pocs]="pocs"
                                    [selectedPocs]="selectedPocs"
                                    [vendorsList]="vendorsList"
                                    [selectedVendors]="selectedVendors"
                                    [sharedJobPocs]="sharedJobPocs"
                                    [showEndClientSection]="!isCorporate && !req?.isSharedClientRequisition"
                                    [endClient]="endClient"
                                    [endClientSearchResults]="endClientTypeAheadResults"
                                    [isLoadingEndClientSearch]="isLoadingEndClientSearch"
                                    [isManageEndClient]="isManageEndClient"
                                    [formalizeActivityPayload]="formalizeActivityPayload"
                                    [step2Error]="step2Error"
                                    [step2Submitted]="step2Submitted"
                                    (editTitleToggleCallback)="editTitleFlag = !editTitleFlag"
                                    (editBUToggleCallback)="editBUFlag = !editBUFlag"
                                    (jobTitleChangeCallback)="validateStepTwo()"
                                    (clientOrBuChangeCallback)="onClientOrBuChanged()"
                                    (sharedClientBuOrCorpChangeCallback)="sharedClientBuOrCorp = $event; onSharedClientChanged(2)"
                                    (updateLocationCallback)="updateLocation()"
                                    (showJobProfileCallback)="showJobProfile()"
                                    (requisitionNumberChangeCallback)="validateStepTwo()"
                                    (openingsChangeCallback)="validateStepTwo()"
                                    (jobTypeSelectedCallback)="selectedJobTypes = $event; onJobTypeSelected('close')"
                                    (workLocationsSelectedCallback)="selectedWorkLocationsList = $event; onWorkLocationsSelected()"
                                    (salaryTypeChangeCallback)="job.jobSalary.salaryType = $event; onSalaryTypeChange($event)"
                                    (sponsorshipProvidedSelectedCallback)="onSponsorshipProvidedSelected()"
                                    (sponsorshipSelectedCallback)="onSponsorshipSelected($event.index, $event.sponsorship)"
                                    (recruitersSelectedCallback)="selectedRecruiters = $event; onRecruitersSelected()"
                                    (hiringManagersSelectedCallback)="selectedHiringManagers = $event; onHiringManagersSelected()"
                                    (primaryHiringManagerSelectedCallback)="onPrimaryHiringManagerSelected($event)"
                                    (vendorsSelectedCallback)="selectedVendors = $event; onVendorsSelected()"
                                    (pocSelectedCallback)="selectedPocs = $event; onPocSelected()"
                                    (endClientSearchCallback)="onEndClientSearch($event)"
                                    (endClientChangeCallback)="onEndClientChange($event)"
                                    (addEditEndClientCallback)="addEditEndClient($event)"
                                    (voiceTranscriptCallback)="onVoiceTranscript($event)"
                                    (receiveFormalizedCommentCallback)="receiveFormalizedComment($event)"
                                    (requiredFieldsValidChange)="step2RequiredFieldsValid = $event">
                                </app-upload-req-step-recruiters>
                            </div>
                            <div class="step-pane sample-pane alert" [class.active]="currentStep === 3" data-step="3">
                                <app-upload-req-step-workflow
                                    [job]="job"
                                    [isCorporate]="isCorporate"
                                    [intelligencePreferences]="intelligencePreferences"
                                    [autoMatchingPreferences]="autoMatchingPreferences"
                                    [recruiterScreeningPreferences]="recruiterScreeningPreferences"
                                    [techAssessmentPreferences]="techAssessmentPreferences"
                                    [techAssessmentList]="techAssessmentList"
                                    [valueAssessmentPreferences]="valueAssessmentPreferences"
                                    [valueAssessmentList]="valueAssessmentList"
                                    [verificationPreferences]="verificationPreferences"
                                    [phoneScreenPreferences]="phoneScreenPreferences"
                                    [interviewPreferences]="interviewPreferences"
                                    [imageProctoringPreferences]="imageProctoringPreferences"
                                    [addImagesToReportPreferences]="addImagesToReportPreferences"
                                    [disableWorkflowSettings]="disableWorkflowSettings"
                                    [candidatesPresentOnJob]="candidatesPresentOnJob"
                                    [isAnyWorkflowStepsEnabled]="isAnyWorkflowStepsEnabled"
                                    [selectedJobType]="selectedJobType"
                                    [workflowStepsOrder]="workflowStepsOrder"
                                    [workflowStepsOrderToRender]="workflowStepsOrderToRender"
                                    [step3Error]="step3Error"
                                    [step3Submitted]="step3Submitted"
                                    (stepSelectionChangeCallback)="onStepSelectionChange($event)"
                                    (assessmentChangeCallback)="onAssessmentChange($event)"
                                    (imageProctoringCheckboxClickCallback)="onImageProctoringCheckboxClick()"
                                    (requiredFieldsValidChange)="step3RequiredFieldsValid = $event">
                                </app-upload-req-step-workflow>
                            </div>
                            <div class="step-pane sample-pane alert" [class.active]="currentStep === 4" data-step="4">
                                <app-upload-req-step-job-boards
                                    [job]="job"
                                    [currentJobStatus]="currentJobStatus"
                                    [editModeFlag]="editModeFlag"
                                    [isTrialPlanActive]="isTrialPlanActive"
                                    [jobBoardsResumePullLeft]="jobBoardsResumePullLeft"
                                    [jobBoardsPullResumePulled]="jobBoardsPullResumePulled"
                                    [isJobIntegrationEnabledByPlan]="isJobIntegrationEnabledByPlan"
                                    [isJobBoardServiceUp]="isJobBoardServiceUp"
                                    [showWizardSteps]="showWizardSteps"
                                    [jobBoardDetailsCopy]="jobBoardDetailsCopy"
                                    [activeJobBoardsFilterTabNumber]="activeJobBoardsFilterTabNumber"
                                    [radiusOptions]="radiusOptions"
                                    [recencyOptions]="recencyOptions"
                                    [resumePullCounts]="resumePullCounts"
                                    [resumesToPullPerJobBoardCountCopy]="resumesToPullPerJobBoardCountCopy"
                                    (useJobBoardChangeCallback)="onUseJobBoardChange()"
                                    (jobBoardSelectionChangeCallback)="onJobBoardSelectionChange()">
                                </app-upload-req-step-job-boards>
                            </div>
                            <div class="step-pane sample-pane info alert" [class.active]="currentStep === 5 && isInitialStateDraft" data-step="5">
                                <app-upload-req-step-activate
                                    [isActivateRequisitionEnabled]="isActivateRequisitionEnabled"
                                    [currentJobStatus]="currentJobStatus"
                                    (activateRequisitionSwitchChangeCallback)="isActivateRequisitionEnabled = $event; onActivateRequisitionSwitchChange()">
                                </app-upload-req-step-activate>
                            </div>
                            <div class="step-pane sample-pane info alert" [class.active]="currentStep === 5 && !isInitialStateDraft" data-step="6">
                                <app-upload-req-step-results
                                    [step5Error]="step5Error"
                                    [intelligencePreferences]="intelligencePreferences"
                                    [currentScoreCandidateCounts]="currentScoreCandidateCounts"
                                    [adjustedScoreCandidateCounts]="adjustedScoreCandidateCounts"
                                    [loadingAdjustedCandidatesCountFlag]="loadingAdjustedCandidatesCountFlag"
                                    [isOutreachEnabled]="isOutreachEnabled"
                                    [sendOutreachEmail]="sendOutreachEmail"
                                    (sendOutreachEmailChange)="sendOutreachEmail = $event">
                                </app-upload-req-step-results>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #jobMatchSalaryPopover>
    <p>{{ job?.requisitionSalaryDisplayMessage }}</p>
</ng-template>

<ng-template #jobMatchSponsorshipsPopover>
    <p *ngIf="job?.sponsorshipsDisplayMessage === 'Not Available' || job?.sponsorshipsDisplayMessage === 'Sponsorship information not specified'">{{ job.sponsorshipsDisplayMessage }}</p>
    <ng-container *ngIf="job?.sponsorshipsDisplayMessage !== 'Not Available' && job?.sponsorshipsDisplayMessage !== 'Sponsorship information not specified'">
        <p class="text-left" *ngFor="let sponsorship of job.sponsorships; let i = index">
            {{ i + 1 }}. {{ sponsorship }}
        </p>
    </ng-container>
</ng-template>

<ng-template #jobWorkLocationsPopover>
    <p *ngIf="job?.workLocations == null">
        <span>Not Available</span>
    </p>
    <ng-container *ngIf="job?.workLocations !== null">
        <p class="text-left" *ngFor="let workLocation of job.workLocations; let i = index">
            {{ i + 1 }}. {{ workLocation.name }}
        </p>
    </ng-container>
</ng-template>
